export const EDU_COMMISSIONS_LIST_REQUEST = 'EDU_COMMISSIONS_LIST_REQUEST'
export const EDU_COMMISSIONS_GET_REQUEST  = 'EDU_COMMISSIONS_GET_REQUEST'
